module.exports = __webpack_public_path__ + "img/book.da69a76f.svg";